<i18n>
{
  "ru":{
    "current_account_balance": "Текущий биллинг баланс",
    "expected_account_balance": "Ожидающие суммы",
    "completed_amt_title": "Завершенные платежи",
    "pending_amt_title": "Авторизованные платежи",
    "system_amt_title": "Системные платежи",
    "refund_amt_title": "Возвраты",
    "recurrent_amt_title": "Рекуррентные платежи",
    "partial_voided_amt_title": "Частичные сбросы",
    "voided_amt_title": "Сброшенные после авторизации"
  },
  "en":{
    "current_account_balance": "Current account balance",
    "expected_account_balance": "Expected value",
    "completed_amt_title": "Completed",
    "pending_amt_title": "Authorized",
    "system_amt_title": "System",
    "refund_amt_title": "Refund",
    "recurrent_amt_title": "Recurrent",
    "partial_voided_amt_title": "Partial voided",
    "voided_amt_title": "Voided"
  }
}
</i18n>
<template>
  <div>
    <el-row class="statistic_payments_wrap">
      <el-col :sm="12">
        <div>
          <h5 class="statistic_pay_header">
            {{ $t("current_account_balance") }}:
          </h5>
          <p class="spatistic_pay_sum" v-if="st.current_account_balance">
            {{ st.current_account_balance }}
            <span v-if="st.current_account_balance_cnt">{{
              st.current_account_balance_cnt
            }}</span>
          </p>
        </div>
        <div>
          <h5 class="statistic_pay_header">{{ $t("completed_amt_title") }}:</h5>
          <p class="spatistic_pay_sum" v-if="st.completed_amt">
            {{ st.completed_amt }}
            <span v-if="st.completed_amt_cnt">{{ st.completed_amt_cnt }}</span>
          </p>
        </div>
        <div>
          <h5 class="statistic_pay_header">{{ $t("system_amt_title") }}:</h5>
          <p class="spatistic_pay_sum" v-if="st.system_fee_amt">
            {{ st.system_fee_amt }}
            <span v-if="st.system_fee_amt_cnt">{{
              st.system_fee_amt_cnt
            }}</span>
          </p>
        </div>
        <div>
          <h5 class="statistic_pay_header">{{ $t("recurrent_amt_title") }}:</h5>
          <p class="spatistic_pay_sum" v-if="st.recurrent_amt">
            {{ st.recurrent_amt }}
            <span v-if="st.recurrent_amt_cnt">{{ st.recurrent_amt_cnt }}</span>
          </p>
        </div>
        <div>
          <h5 class="statistic_pay_header">{{ $t("voided_amt_title") }}:</h5>
          <p class="spatistic_pay_sum" v-if="st.voided_amt">
            {{ st.voided_amt }}
            <span v-if="st.voided_amt_cnt">{{ st.voided_amt_cnt }}</span>
          </p>
        </div>
        <!-- <div>
                <h5 class="statistic_pay_header">Комиссия:</h5>
                <p class="spatistic_pay_sum">100.00
                  <span>rub</span>
                </p>
              </div> -->
      </el-col>
      <el-col :sm="12">
        <div>
          <h5 class="statistic_pay_header">
            {{ $t("expected_account_balance") }}:
          </h5>
          <p class="spatistic_pay_sum" v-if="st.expected_account_balance">
            {{ st.expected_account_balance }}
            <span v-if="st.expected_account_balance_cnt">{{
              st.expected_account_balance_cnt
            }}</span>
          </p>
        </div>
        <div>
          <h5 class="statistic_pay_header">{{ $t("pending_amt_title") }}:</h5>
          <p class="spatistic_pay_sum" v-if="st.pending_amt">
            {{ st.pending_amt }}
            <span v-if="st.pending_amt_cnt">{{ st.pending_amt_cnt }}</span>
          </p>
        </div>
        <div>
          <h5 class="statistic_pay_header">{{ $t("refund_amt_title") }}:</h5>
          <p class="spatistic_pay_sum" v-if="st.refund_amt">
            {{ st.refund_amt }}
            <span v-if="st.refund_amt_cnt">{{ st.refund_amt_cnt }}</span>
          </p>
        </div>
        <div>
          <h5 class="statistic_pay_header">
            {{ $t("partial_voided_amt_title") }}:
          </h5>
          <p class="spatistic_pay_sum" v-if="st.partial_voided_amt">
            {{ st.partial_voided_amt }}
            <span v-if="st.partial_voided_amt_cnt">{{
              st.partial_voided_amt_cnt
            }}</span>
          </p>
        </div>
      </el-col>
    </el-row>

    <hr />
  </div>
</template>

<script>
export default {
  props: ['st'],
  name: 'statistic'
}
</script>
